import * as React from "react"

const SvgComponent = ({
    onClick
}: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.4" height="15.4" viewBox="0 0 15.4 15.4" onClick={onClick}>
            <g data-name="plus icon">
                <path data-name="Path 2308" d="M1 11h14" transform="translate(-.3 -3.3)" fill="none" stroke="#264f36" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4px" />
                <path data-name="Path 2309" d="M11 1v14" transform="translate(-3.3 -.3)" fill="none" stroke="#264f36" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4px" />
            </g>
        </svg>
    )
}

export default SvgComponent
